const styles = (theme) => ({
  icon: {
    fontSize: 30,
    marginRight: theme.spacing(1),
    height: 'auto',
  },
});

export default styles;
